import { request } from '../../request';
import { SingleShift } from '@libs/models/shifts/shift';

export type SingleShiftEditData = Omit<SingleShift, 'startDate'> & {
  startDate: string;
  specialty?: string;
  unassignReason?: string;
  doubleShiftOptions?: {
    isDoubleShift: boolean;
    overlappedShiftId: string;
  };
};

export async function updateSingleShift(shiftId: string, data: SingleShiftEditData) {
  return request.patch<void>(`/v2/shifts/${shiftId}`, {
    staffingType: data.staffingType,
    date: {
      startDate: { dateTime: data.startDate, timezone: data.timeZone },
      durationInSeconds: data.durationInSeconds,
      timeZone: data.timeZone,
    },
    staffNurseQualificationFilterIds: data.staffNurseQualificationFilterIds,
    speciality: {
      isEmpty: !data.specialtyId,
      id: data.specialtyId || null,
    },
    subDepartment: {
      isEmpty: !data.subDepartmentNodeId,
      id: data.subDepartmentNodeId || null,
    },
    assignee: {
      isEmpty: !data.assignees.length,
      id: data.assignees.length ? data.assignees[0] : null,
      unassignReason: data.unassignReason,
    },
    departmentNodeId: data.departmentNodeId,
    locationId: data.locationId,
    tags: data.tags.reduce((acc, elem) => {
      if (elem) {
        acc.push(elem);
      }
      return acc;
    }, [] as string[]),
    note: data.note,
    isUrgent: data.isUrgent,
    doubleShiftOptions: data.doubleShiftOptions
      ? {
          isDoubleShift: data.doubleShiftOptions.isDoubleShift,
          overlappedShiftId: data.doubleShiftOptions.overlappedShiftId,
        }
      : {
          isDoubleShift: false,
          overlappedShiftId: null,
        },
  });
}
